import {combineReducers} from 'redux';
import userInfoReducer from "./UserInfoReducer";

export default combineReducers({
    userInfoReducer
});